<template>
  <div v-loading="isBusy">
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      element-loading-spinner="el-icon-loading"
      label-width="170px"
    >
      <el-collapse v-model="collapse" accordion>
        <el-collapse-item title="Sender and Receiver Information" name="info">
          <el-row>
            <el-col :span="24">
              <div class="w-100 text-left mb-3">
                <p><b>To:</b> {{ getEmailAddressPresentation }}</p>
                <el-form-item prop="outgoing_number_id" label="Outgoing Number">
                  <el-select
                    v-model="form.outgoing_number_id"
                    class="w-100"
                    filterable
                  >
                    <el-option
                      v-for="item in outgoingNumberList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="24">
              <div class="alert alert-success mb-3 text-center" role="alert" v-if="contactExist">
                The contact already exist.
              </div>
              <div class="w-100 text-left font-weight-bold mb-3 text-uppercase">
                <p>From:</p>
              </div>
              <el-form-item label="ID" prop="id">
                <el-input v-model="form.id" disabled></el-input>
              </el-form-item>
              <el-form-item label="First Name" prop="first_name">
                <el-input v-model="form.first_name" :disabled="this.contactExist"></el-input>
              </el-form-item>
              <el-form-item label="Last Name" prop="last_name">
                <el-input v-model="form.last_name" :disabled="this.contactExist"></el-input>
              </el-form-item>
              <el-form-item label="Email" prop="email">
                <el-input v-model="form.email" disabled></el-input>
              </el-form-item>
              <el-form-item label="Filemaker ID" prop="filemaker_id">
                <el-input v-model="form.filemaker_id" :disabled="this.contactExist"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-collapse-item>
        <el-collapse-item title="Subject and Message" name="message">
          <div class="w-100 text-left mb-3 text-uppercase">
            <p><b>Subject:</b> {{ getSubject }}</p>
            <p><b>Message:</b></p>
          </div>
          <iframe-loader :url="previewUrl" v-if="collapse === 'message'"></iframe-loader>
        </el-collapse-item>
      </el-collapse>
    </el-form>
    <button class="btn btn-purple px-4 mt-3" @click="store">Approve</button>
  </div>
</template>

<script>
import BaseForm from '../form';
import IframeLoader from '../iframe-loader';

export default {
  extends: BaseForm,

  components: {
    IframeLoader,
  },

  props: {
    contact: Object,
    emailAddress: Object,
    emailMessage: Object,
    previewUrl: String,
    outgoingNumberList: Array,
  },

  data() {
    const form = {
      first_name: null,
      last_name: null,
      phone_number: null,
      filemaker_id: null,
      email: null,
      id: null,
      outgoing_number_id: null,
    };

    return {
      form,
      rules: _.mapValues(form, () => [{validator: this.fieldExternalValidator}]),
      collapse: 'info',
    }
  },

  computed: {
    /**
     * @return {boolean}
     */
    contactExist() {
      return !_.isNull(_.get(this.form, 'id'));
    },

    /**
     * @return {String}
     */
    getEmailAddressPresentation() {
      let email = _.get(this.emailAddress, 'address');
      let title = _.get(this.emailAddress, 'title');

      return `${title} - ${email}`;
    },

    /**
     * @returns {String}
     */
    getSubject() {
      return _.get(this.emailMessage, 'subject');
    },

    getSentAt() {

    },
  },

  methods: {
    /**
     */
    initForm() {
      this.form = _.mapValues(this.form, (val, prop) =>
        _.get(this.contact, prop, null)
      );
    },
  },
}
</script>
